import { Address } from "../../../api/types/address"
import { RegisterUserPayload } from "../../../api/types/auth"
import { regex } from "../../../common/regex"
import { FormErrors } from "../../FieldError"

export const validateAddress = (address: Address): [boolean, FormErrors<Address>] => {
  let isValid: boolean = true
  let errors: FormErrors<Address> = {}

  if (!address.name) {
    errors.name = "Název společnosti je povinné pole."
    isValid = false
  }

  if (!address.street) {
    errors.street = "Ulice a číslo domu je povinné pole."
    isValid = false
  }

  if (!address.zip) {
    errors.zip = "PSČ je povinné pole."
    isValid = false
  }

  if (!address.city) {
    errors.city = "Obec je povinné pole."
    isValid = false
  }

  if (!address.country) {
    errors.country = "Země je povinné pole."
    isValid = false
  }

  if (address.country === "CZ") {
    if (!address.ic) {
      errors.ic = "IČ je povinné pole."
      isValid = false
    } else {
      if (!regex.IC.test(address.ic)) {
        errors.ic = "IČ není ve správném formátu."
        isValid = false
      }
    }
  }

  if (!address.dic) {
    errors.dic = "DIČ je povinné pole."
    isValid = false
  } else {
    if (!regex.DIC.test(address.dic)) {
      errors.dic = "DIČ není ve správném formátu."
      isValid = false
    }
  }

  return [isValid, errors]
}

export const validateUser = (account: RegisterUserPayload): [boolean, FormErrors<RegisterUserPayload>] => {
  let isValid: boolean = true
  let errors: FormErrors<RegisterUserPayload> = {}

  if (!account.firstname) {
    errors.firstname = "Jméno je povinné pole."
    isValid = false
  }

  if (!account.lastname) {
    errors.lastname = "Příjmení je povinné pole."
    isValid = false
  }

  if (!account.email) {
    errors.email = "E-mail je povinné pole."
    isValid = false
  }

  if (!account.billingEmail) {
    errors.billingEmail = "E-mail pro fakturaci je povinné pole."
    isValid = false
  }

  if (!account.mobile && !account.phone) {
    errors.mobile = "Mobil je povinné pole."
    isValid = false
  }

  if (!account.phone && !account.mobile) {
    errors.phone = "Telefon je povinné pole."
    isValid = false
  }

  // if (!account.billingAddress) {
  //   errors.billingAddress = "Přiřazení k fakturační adrese je povinné pole."
  //   isValid = false
  // }

  return [isValid, errors]
}
